import { captureException } from '@sentry/react'
import { type UseQueryOptions, useQuery } from '@tanstack/react-query'
import {
	type HttpGetImagesMetadataOptions,
	HttpGetImagesMetadataResponse,
	httpGetImagesMetadata
} from '@/features/photoset/http/photoset.http'
import { parseAxiosPromise } from '@/helpers/utils'
import { QUERY_KEYS } from '@/query-client'

export const useGetImagesMetadata = (
	promiseArgs: HttpGetImagesMetadataOptions,
	options?: Omit<
		UseQueryOptions<HttpGetImagesMetadataResponse>,
		'queryFn' | 'queryKey'
	>
) =>
	useQuery({
		...options,
		queryKey: [QUERY_KEYS.IMAGE_METADATA, promiseArgs],
		queryFn: () =>
			parseAxiosPromise({
				axiosPromise: httpGetImagesMetadata(promiseArgs),
				responseShape: HttpGetImagesMetadataResponse,
				onZodError: captureException
			})
	})
